import React from 'react';
import { STATUS, fmtDateTime } from './deviceRequestApi';

const show = (v) => {
    if (v === null || v === undefined || v === '') return '—';
    if (typeof v === 'object') return JSON.stringify(v);
    return String(v);
};

const DeviceRequestTimeline = ({ history = [] }) => (
    <ul className="list-unstyled small mb-0" data-testid="dr-timeline">
        {history.map((h, i) => (
            <li key={i} className="border-start border-3 ps-2 mb-2">
                <strong>{fmtDateTime(h.at)}</strong> — {h.actorName} <span className="text-muted">({h.actorRole})</span>: {h.action}
                {h.toStatus && <> → <em>{(STATUS[h.toStatus] || {}).label || h.toStatus}</em></>}
                {h.reason && <div className="text-muted">Reason: {h.reason}</div>}
                {(h.changes || []).map((c, j) => (
                    <div key={j} className="text-muted">
                        {c.field}: {show(c.from)} → {show(c.to)}
                    </div>
                ))}
            </li>
        ))}
    </ul>
);

export default DeviceRequestTimeline;
